import type { UnwrapNestedRefs } from "vue";
import type { ComponentPublicInstance, Ref, VNode } from "vue";
import type { QuickFormPropsType } from "../../QuickForm/src";

import type { DataTableType } from "../../DataTable/src/types";
import type { QuickFormType } from "../../QuickForm/src/types";

export interface FetchApiInterface {
  (fetchAllData: any, fetchConf: any): Promise<any>;
}
// url方法请求类型,传入当前请求数据，返回请求方法
export interface UrlFunctionType {
  (fetchDataAll: unknown): string;
}
// 配置查询的方式类型
export interface FetchTypeConfType {
  GET: string;
  POST: string;
  PUT: string;
  DELETE: string;
}
// 支持的请求方式枚举
export const FetchTypeConf: FetchTypeConfType = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};
export type FetchTypeConfKeyType = keyof typeof FetchTypeConf;
// 配置查询的数据过滤方法，在前置过滤支后
export interface FetchDataFilterType {
  (res: unknown): unknown;
}

export interface AfterMountedInterface {
  (ctx: unknown): unknown;
}

export interface AfterDestroyedInterface {
  (ctx: unknown): unknown;
}

export interface SearchBarWrapperInterface {
  (
    setSearchFormAttrs: Partial<QuickFormPropsType>,
    searchFormVnode: VNode
  ): VNode;
}

export interface ToggleSearchFormFuncInterface {
  (): void;
}

export interface ToggleRenderInterface {
  (
    formValue: any,
    toggleSearchFormFunc: ToggleSearchFormFuncInterface,
    showSearchFormAll: boolean
  ): RenderNodesType;
}
export interface SearchBarWrapperInterface {
  (
    setSearchFormAttrs: Partial<QuickFormPropsType>,
    searchFormVnode: VNode
  ): VNode;
}

export interface TopBtnRenderInterface {
  (
    mutipleSelection: any[],
    _ctx: BaseListType & ComponentPublicInstance
  ): RenderNodesType;
}
export interface searchFormType {
  [propName: string]: string;
}
export interface ListDataStateType {
  showSearchForm: boolean;
  showSearchFormAll: boolean;
  searchForm: searchFormType;
  listPageTableHeight: boolean;
  mutipleSelection: Array<any>;
}
export type BaseListRefsType = {
  baseTableObject?: DataTableType;
  searchFormObject?: QuickFormType;
};
export interface BaseListType {
  listDataState: UnwrapNestedRefs<ListDataStateType>;
  searchForm: any;
  searchBarWrapperRender(): RenderNodesType;
  baseTableRef(el: DataTableType): any;
  searchDataFunc(): void;
  refsObject: BaseListRefsType;
  lightReloadList(reset: boolean): void;
  reloadList(reset: boolean): void;
  changeSelectRow(d: any[]): void;
  headerTopBlockRender(): any;
  resetSearch(): void;
  toggleSearchFormFunc(): void 
  searchFormWrap(): any;
  onSearchSubmit(v:any): void;
}
export type RenderNodesType = VNode[] | VNode | null | string;
export interface BaseListSearchFormItemConfType {
  fixedShow?: boolean; //在baselist搜索表单时候是否一直显示
  toggleButton?: boolean; //是否是切换的按钮项
  toggleRender?: ToggleRenderInterface; //切换按钮的渲染方法
}
